import { isoWebPageURL } from "../../models/nominals";
import { useIsSSR } from "../../utils/ssr";
import urls from "../../utils/urls";

export const useSiteURLs = () => {
    const isSSR = useIsSSR();

    return {
        chatOfflineURL: isSSR
            ? isoWebPageURL.wrap(
                  "https://help.tempurpedic.com/hc/en-us/requests/new?ticket_form_id=1500000575301&_ga=2.88345756.608968453.1737471361-1260627659.1708960090",
              )
            : urls.pageURL("contact-link"),
        customerServiceURL: isSSR
            ? isoWebPageURL.wrap("/")
            : urls.pageURL("customer-service"),
        customerLoginURL: isSSR
            ? isoWebPageURL.wrap("/")
            : urls.pageURL("customer-login"),
        customerRegisterURL: isSSR
            ? isoWebPageURL.wrap("/")
            : urls.pageURL("customer-register"),
    };
};
